//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ColFilter",
  props: ["fieldName", "filterOptions", "filterValues", "isAscending"],
  mounted: function () {
    this.selectedItems = this.filterValues;
  },
  data: function () {
    return {
      filterState: true,
      list: this.filterOptions,
      invertSortStatus: false,
      sortState: this.isAscending,
      selectedItems: [],
    };
  },
  methods: {
    invertSort: function () {
      if (this.sortState === null) {
        this.sortState = true;
      } else {
        this.sortState = !this.sortState;
      }
    },
    emitSelectedFilter() {
      this.$emit("selected-filter", {
        invertSort: this.invertSortStatus,
        sortState: this.sortState,
        selectedItems: this.selectedItems,
      });
    },
    sortIcon: function () {
      if (this.sortState !== null) {
        return this.sortState ? "mdi-arrow-up" : "mdi-arrow-down";
      } else {
        return "mdi-moon-full";
      }
    },
    filterFn: function (val, update) {
      update(() => {
        const needle = val.toLowerCase();
        this.list = this.filterOptions.filter(
          (v) => v.toLowerCase().indexOf(needle) > -1
        );
      });
    },
  },
  watch: {

  },
};
